import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Fragment } from 'react';
import { I18n } from 'react-redux-i18n-lite';
import { SmartButton } from '../../common/SmartButton';

import SadMonster from './SadMonster';
import { ROLE } from '../../../const';

export class EmptyListPlaceholder extends React.Component {
  static propTypes = {
    manageButtonClick: PropTypes.func,
    buttonLabel: PropTypes.string,
    label: PropTypes.string,
    role: PropTypes.string,
    hiddenButton: PropTypes.func
  };

  isTeacher = () => this.props.role === ROLE.INSTRUCTOR;

  renderContentButton() {
    const { manageButtonClick, buttonLabel, hiddenButton } = this.props;

    if (this.isTeacher() && (hiddenButton !== undefined ? !hiddenButton() : true)) {
      return (
        <SmartButton id="no-content-button" disabled={false} onClick={manageButtonClick} success>
          {I18n.t(buttonLabel)}
        </SmartButton>
      );
    }
    return <Fragment />;
  }

  render() {
    const { label } = this.props;

    return (
      <div className="empty-classroom">
        <SadMonster msgKey={label} />
        {this.renderContentButton()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { role: state.classrooms.selectedClassroom.classroom.role };
}

export default connect(mapStateToProps)(EmptyListPlaceholder);
